
var ZVUS_KEY = "XNpMRQ";
// US list.
var ZVUS_LIST = window.ZVShop.listId;

function zvUsSay(t){ var m = document.getElementById('zvUsMsg'); if (m) m.textContent = t; }

function zvUsPost(path, body){
  return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + ZVUS_KEY, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
    body: JSON.stringify(body)
  }).then(function(r){
    if (r.status === 202 || r.ok) return true;
    throw new Error(path + ' ' + r.status);
  });
}

function zvUsJoin(){
  var email = document.getElementById('zvUsEmail').value.trim();
  var ageEl = document.getElementById('zvUsAge');
  var age = ageEl ? ageEl.value : '';
  var b = document.getElementById('zvUsJoin');
  zvUsSay('');
  if (!email || email.indexOf('@') < 1 || email.indexOf('.') < 0){ zvUsSay('Please enter a valid email address.'); return; }
  b.disabled = true; b.textContent = 'One moment…';

  var props = { signup_source: 'us-advertorial-how-much-price', market: 'US' };
  if (age) props.age_range = age;

  // Both calls are required. /client/subscriptions/ sets consent and list membership but
  // writes NO properties onto a profile that already exists (proven 2026-08-11).
  // /client/profiles/ writes the fields on new and existing profiles alike.
  var subPayload = {
    data: {
      type: 'subscription',
      attributes: { profile: { data: { type: 'profile', attributes: { email: email, properties: props } } } },
      relationships: { list: { data: { type: 'list', id: ZVUS_LIST } } }
    }
  };
  var profPayload = { data: { type: 'profile', attributes: { email: email, properties: props } } };

  // Custom event so signups are countable as a metric.
  var evtPayload = {
    data: {
      type: 'event',
      attributes: {
        properties: { age_range: age || 'not given', source: 'us-advertorial-how-much-price' },
        metric: { data: { type: 'metric', attributes: { name: 'Joined US waitlist' } } },
        profile: { data: { type: 'profile', attributes: { email: email } } }
      }
    }
  };

  zvUsPost('subscriptions', subPayload)
    .then(function(){ return zvUsPost('profiles', profPayload); })
    .then(function(){
      // The event is optional; never let it block the confirmation.
      return zvUsPost('events', evtPayload).catch(function(){ return true; });
    })
    .then(function(){
      document.getElementById('zvUsForm').style.display = 'none';
      document.getElementById('zvUsNote').style.display = 'none';
      document.getElementById('zvUsOk').classList.add('show');
      if (window.fbq) { if (window.ZVAM && typeof window.ZVAM.lead === 'function') { window.ZVAM.lead({}, { email: email }); } else { fbq('track','Lead'); } }
    })
    .catch(function(){
      b.disabled = false; b.textContent = 'Put me on the list';
      zvUsSay('Something went wrong. Please try again.');
    });
}

document.addEventListener('keydown', function(e){
  if (e.key === 'Enter' && document.activeElement && document.activeElement.id === 'zvUsEmail') zvUsJoin();
});

;

// Market-aware price. Do not type a figure into this page again.
// First paint uses the map so there is no flicker, then the live product price
// overwrites it, so a price change in Shopify reaches this page on its own.
(function(){
  var SYMBOL = { USD:'$', GBP:'£', EUR:'€' };
  var FIRST_PAINT = { USD:6900, GBP:4900 };
  var code = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
  function fmt(cents){
    var v = cents / 100;
    return (SYMBOL[code] || code + ' ') + (v % 1 === 0 ? v.toFixed(0) : v.toFixed(2));
  }
  function paint(cents){
    window.ZV_PRICE = fmt(cents);
    var n = document.querySelectorAll('.zv-price-auto');
    for (var i = 0; i < n.length; i++) n[i].textContent = window.ZV_PRICE;
  }
  if (FIRST_PAINT[code]) paint(FIRST_PAINT[code]);
  fetch('/products/the-pdrn-serum.js', { headers:{ 'Accept':'application/json' } })
    .then(function(r){ return r.ok ? r.json() : null; })
    .then(function(p){ if (p && typeof p.price === 'number') paint(p.price); })
    .catch(function(){});
})();
